import { render, staticRenderFns } from "./WebScrapingAPI.vue?vue&type=template&id=f0507268&scoped=true"
import script from "./WebScrapingAPI.vue?vue&type=script&lang=js"
export * from "./WebScrapingAPI.vue?vue&type=script&lang=js"
import style0 from "./WebScrapingAPI.vue?vue&type=style&index=0&id=f0507268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0507268",
  null
  
)

export default component.exports